import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ClientSettingName, IClientSettings, ICreditClientSettingSetValue } from "@vmosolutions/oc-interfaces";
import { getClientSetting } from "../actions/App.Actions";

export type ICreditSettingsState = ICreditClientSettingSetValue;

const initialState: ICreditSettingsState = {
  hidePlannedCreditField: false,
  useAdditionalPlannedCreditInBidAssignment: false,
  settings: [],
};

export const getCreditSettings = createAsyncThunk("creditsettings/get", async () => {
  const settings: IClientSettings = await getClientSetting(ClientSettingName.Credit);
  return settings?.setValue ?? ({} as ICreditClientSettingSetValue);
});

export const Credit = createSlice({
  name: "Credit",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getCreditSettings.fulfilled, (state, action: PayloadAction<ICreditClientSettingSetValue>) => {
      state.hidePlannedCreditField = action.payload.hidePlannedCreditField;
      state.useAdditionalPlannedCreditInBidAssignment = action.payload.useAdditionalPlannedCreditInBidAssignment;
      state.settings = action.payload.settings;
      // The calculated-credit rollout switches, including the master kill switch the UI gates on.
      state.calculatedCredit = action.payload.calculatedCredit;
    });
  },
});

export default Credit.reducer;
